export const VolumeMenuIcon = ({
    width = 16,
    height = 16,
    color = "#1D201E",
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width={width} height={height} fill="white" fill-opacity="0.01" />
        <path
            d="M17.5 17.5V3.75H12.5V17.5H10V8.75H5V17.5H2.5V1.25H1.25V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H18.75V17.5H17.5ZM13.75 5H16.25V11.25H13.75V5ZM6.25 10H8.75V13.75H6.25V10Z"
            fill={color}
        />
    </svg>
);
